<template>
  <div class="serverContent">
    <div class="oper">
      <el-button v-if="add" type="primary" size="small" @click="addServer">
        新增服务器
      </el-button>
      <el-button v-if="deleBatch" size="small" type="danger" plain @click="deleteBatchServer">
        批量删除
      </el-button>
      <el-input v-model="searchkeyWord" class="rightSearch" placeholder="请选择所属地区/服务器地址/备注信息" size="small"
        suffix-icon="el-icon-search" @input="getAccelerationServerList"></el-input>
    </div>
    <div class="serverTable">
      <el-table ref="multipleTable" :data="tableData" border size="small" height="100%" row-key="serverId"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column prop="serverArea" label="所属区域">
          <template #default="{ row }">
            <el-link v-if="edit" type="primary" @click="cellClick(row)">
              <span class="tabLinkSpan" :title="row.serverArea">{{ row.serverArea }}</span>
            </el-link>
            <span v-else class="tabLinkSpan" :title="row.serverArea">{{ row.serverArea }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="serverUrl" label="服务器地址">
        </el-table-column>
        <el-table-column prop="remark" label="备注">
        </el-table-column>
        <el-table-column prop="operUserName" label="创建人" align="center">
        </el-table-column>
        <el-table-column v-if="edit||dele" label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="edit" size="mini" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button v-if="dele" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增编辑 -->
    <el-dialog v-dialogDrag :title="serverTitle" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="110px">
        <el-form-item label="所属区域：" prop="serverArea">
          <el-input ref="serverArea" v-model="form.serverArea"></el-input>
        </el-form-item>
        <el-form-item label="服务器地址：" prop="serverUrl">
          <el-input v-model="form.serverUrl"></el-input>
        </el-form-item>
        <el-form-item label="备 注：">
          <el-input v-model="form.remark" type="textarea" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sysServerService from "@/CommonDP/service/sysServer-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  data() {
    return {
      add: checkPermission(this.$allPerms.SYSTEMSET_ADD),
      edit: checkPermission(this.$allPerms.SYSTEMSET_EDIT),
      dele: checkPermission(this.$allPerms.SYSTEMSET_DALE),
      deleBatch: checkPermission(this.$allPerms.SYSTEMSET_DELEBATCH),
      tableData: [],
      dialogVisible: false,
      isAdd: false,
      form: {
        serverArea: "",
        serverUrl: "",
        remark: ""
      },
      serverId: "",
      rules: {
        serverArea: [{ required: true, message: "请选择所属区域", trigger: "change" }],
        serverUrl: [{ required: true, message: "请选择服务器地址", trigger: "change" }]
      },
      serverTitle: "",
      searchkeyWord: "",
      multipleSelection: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    addParams() {
      const params = {
        enterpriseId: this.enterpriseId,
        isDelete: 0,
        operDate: "",
        operUserId: "",
        operUserName: "",
        orderNum: 0,
        remark: this.form.remark,
        serverArea: this.form.serverArea,
        serverId: "",
        serverUrl: this.form.serverUrl
      };
      return params;
    },
    editParams() {
      const params = {
        enterpriseId: this.enterpriseId,
        isDelete: 0,
        operDate: "",
        operUserId: "",
        operUserName: "",
        orderNum: 0,
        remark: this.form.remark,
        serverArea: this.form.serverArea,
        serverId: this.serverId,
        serverUrl: this.form.serverUrl
      };
      return params;
    }
  },
  mounted() {
    this.getAccelerationServerList();
  },
  methods: {
    async getAccelerationServerList() {
      const res = await sysServerService.accelerationServerList(this.enterpriseId, this.searchkeyWord);
      this.tableData = res.data || [];
    },
    addServer() {
      this.serverTitle = "新增服务器";
      this.isAdd = true;
      this.form.serverArea = "";
      this.form.serverUrl = "";
      this.form.remark = "";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.serverArea.focus();
        this.$refs.form.clearValidate();
      });
    },
    handleEdit(row) {
      this.serverTitle = "编辑服务器";
      this.isAdd = false;
      this.form.serverArea = row.serverArea;
      this.form.serverUrl = row.serverUrl;
      this.form.remark = row.remark;
      this.serverId = row.serverId;
      this.dialogVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("确定删除该条服务器？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(async () => {
          this.serverId = row.serverId;
          try {
            await sysServerService.accelerationServerbatchDelete([this.serverId]);
            this.$message.success("删除成功");
            this.getAccelerationServerList();
          } catch (error) {
            console.warn(error);
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量删除
    deleteBatchServer() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("确定删除目前选中的服务器？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(async () => {
            try {
              const ids = [];
              this.multipleSelection.forEach(ele => {
                ids.push(ele.serverId);
              });
              await sysServerService.accelerationServerbatchDelete(ids);
              this.$message.success("删除成功");
              this.getAccelerationServerList();
            } catch (error) {
              console.warn(error);
            }
          })
          .catch(() => {
            this.$message.info("已取消");
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = [];
          });
      } else {
        this.$message.info("请至少选择一条需要删除的服务器");
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async sure() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.isAdd) {
            try {
              await sysServerService.accelerationServerAdd(this.addParams);
              this.$message.success("新增成功");
              this.dialogVisible = false;
              this.getAccelerationServerList();
            } catch (error) {
              console.warn(error);
              this.dialogVisible = false;
            }
          } else {
            try {
              await sysServerService.accelerationServerUpdate(this.editParams);
              this.$message.success("编辑成功");
              this.dialogVisible = false;
              this.getAccelerationServerList();
            } catch (error) {
              console.warn(error);
              this.dialogVisible = false;
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.serverContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .oper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: var(--middle-space);
    .rightSearch {
      margin-left: auto;
      width: 300px;
    }
  }
  .serverTable {
    width: 100%;
    height: 1px;
    flex-grow: 1;
  }
}
</style>
